/**
 * Returns a browser-playable URL for audio controls.
 *
 * We do not rewrite to any local proxy route.
 */
export function toBrowserPlayableMusicUrl(url: string): string {
  return url.trim();
}
